import React from 'react'

const SearchRawCount = React.memo(({ count }) => {
  return count > 0 ? <span>{Number(count).toLocaleString()}</span> : null
})

export default SearchRawCount
